import { PrivacyPolicy } from "@stories/pages/Home/PrivacyPolicy";

export const PrivacyPolicyView = () => {
  return <PrivacyPolicy />;
};
